import { Component, OnInit } from "@angular/core";
import { BzgModalRef } from 'bz-genome-angular';

@Component({
    selector: 'app-workspace-migration-modal',
    templateUrl:'./workspace-migration-modal.component.html',                    
    styleUrls: ['./workspace-migration-modal.component.scss']                   
})
export class WorkspaceMigrationModalComponent implements OnInit {

    constructor(public modalComponentRef: BzgModalRef) { }
    
    ngOnInit(){        
    }

    close() {
        this.modalComponentRef.close({
            cancel: true
        });
    }

    OnYes() {
        this.modalComponentRef.close({
            cancel: false,
            action: true          
        });
    }

    OnNot() {
        this.modalComponentRef.close({
            cancel: false,
            action: false          
        });
    }
}
